import * as Yup from 'yup'

const journeySchema = Yup.object().shape({
  journey_name: Yup.string()
    .max(100, 'validation-name-max')
    .nullable()
    .required('validation-required'),
  code: Yup.string().required('validation-required'),
  description: Yup.string().optional().nullable(),
  image: Yup.object().shape({
    icon: Yup.string().nullable(),
  }),
  media: Yup.array().optional(),
  products: Yup.array(),
})

export { journeySchema }
